<app-header></app-header>

<!-- section start -->
<section class="section-b-space">
	<div class="container">
		<div class="row">
			@if (loggedUser) {
			<div class="col-lg-3">
				<div
					class="account-sidebar"
					(click)="ToggleDashboard()">
					<a
						hre="javascript:void(0)"
						class="popup-btn">
						<i
							aria-hidden="true"
							class="fa fa-bars"></i>
						{{'my-account' | translate}}
					</a>
				</div>
				<div
					class="dashboard-left"
					[class.open]="openDashboard">
					<div
						class="collection-mobile-back"
						(click)="ToggleDashboard()">
						<span class="filter-back">
							<i
								class="fa fa-angle-left"
								aria-hidden="true"></i>
							{{'buttons.close' | translate}}
						</span>
					</div>
					<div class="block-content">

						<ul>
							<li
								*ngFor="let sub of subsections"
								[class.active]="selected == sub.title"
								(click)="handleClickSubsection(sub)">
								<a>{{ sub.label| translate}}</a>

							</li>

							<li *ngIf="false">
								<a href="javascript:void(0)">{{'newsletter' | translate}}</a>
							</li>
							<li
								(click)="logout()"
								class="last logout text-danger">
								<a>{{'buttons.logout' | translate}}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			}
			<div class="{{loggedUser? 'col-lg-9' : 'col-lg-12'}}">
				
						<router-outlet></router-outlet>
					</div>
			
		</div>
	</div>
</section>
<app-footer></app-footer>
